import { Component, Input } from "@angular/core";
import { FlightModel } from "@/_models/flight/flight.model";
import { SharedComponentsModule } from "../../shared/shared-components.module";
import { FieldExcludesFilterPipe } from "@/_pipes/field-excludes-filter.pipe";
import { NgClass } from "@angular/common";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-home-task-card",
    standalone: true,
    imports: [
        SharedComponentsModule,
        FieldExcludesFilterPipe,
        NgClass,
        TagModule,
    ],
    templateUrl: "./home-task-card.component.html",
    styleUrl: "./home-task-card.component.scss",
})
export class HomeTaskCardComponent {
    @Input() flight: FlightModel;
    @Input() showEdit: boolean = false;
    @Input() isLast: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
